import { render, staticRenderFns } from "./BrandedHeader.vue?vue&type=template&id=6fbf9d8d&scoped=true&"
import script from "./BrandedHeader.vue?vue&type=script&lang=ts&"
export * from "./BrandedHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BrandedHeader.vue?vue&type=style&index=0&id=6fbf9d8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf9d8d",
  null
  
)

export default component.exports